import CustomForm from "../../CustomForm";
import m, {Vnode} from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import KandidatDefault from "./components/KandidatDefault";
import {CheckboxItem} from "../../../model/items/checkbox";

export default class KandidatiDefault extends CustomForm {

    private readonly restLabel: string;
    private readonly diffLabel: string;
    private readonly target: number;
    private readonly step: number;

    private readonly checkBoxValid?: CheckboxItem;
    private readonly kandidats: (KandidatDefault|null)[] = [];

    constructor(settings: ICustomFormSettings) {
        super(settings);

        this.target = Number(settings.form.aux3 || 0) || 0;
        this.step = Number(settings.form.aux2 || 1) || 1;

        const layout = settings.form.grid.layout;

        this.checkBoxValid = <CheckboxItem>layout[0][3]?.getItems()[0];
        this.restLabel = layout[0][0]?.getItems()[0].label || "{rest}";
        this.diffLabel = layout[0][1]?.getItems()[0].label || "{diff}";

        for (let i=1; i<layout.length; i++) {
            try {
                const row = KandidatDefault.parseRow(layout[i]);
                this.kandidats.push(new KandidatDefault(row, this));
            } catch (err) {
                console.warn(`customForm-kandidati: Row(${i}) ${err.message}`);
                this.kandidats.push(null);
            }
        }
    }

    public round(value: number): number {
        if (this.step) {
            value /= this.step;
            value = Math.round(value);
            value *= this.step;
        }
        return value;
    }

    public triggerChange(): void {
        this.checkBoxValid?.setVariable(this.getDiff() === 0);
    }

    checkRequirements(): boolean {
        if (this.kandidats.filter(k => !k).length) {
            console.warn("customForm-kandidati: Invalid rows with Kandidat.")
            return false;
        }


        return super.checkRequirements();
    }

    private getSum(): number {
        return this.kandidats.reduce((p, k) => p + (k?.getValue() ?? 0), 0);
    }

    private getDiff(): number {
        if (!this.target) {
            return 0;
        }
        return this.round(this.target - this.getSum());
    }

    public viewRestDiff(cssClass = 'kandidati-status'): Vnode|null {
        const diff = this.getDiff();
        const questionary = this.settings.form.questionary;
        const visible = diff === this.target ? '' : '.visible';
        if (diff > 0) {
            return m(`.${cssClass}.rest${visible}`, {}, m.trust( questionary.renderText(this.restLabel).replace('{rest}', diff.toLocaleString()) ));
        } else if (diff < 0) {
            return m(`.${cssClass}.diff${visible}`, {}, m.trust( questionary.renderText(this.diffLabel).replace('{diff}', (-diff).toLocaleString()) ));
        }
        return m(`.${cssClass}`);
    }

    public view(): Vnode {
        return this.viewLayout([
            this.viewRestDiff(),
            m('.kandidati', {}, this.kandidats.map(k => k?m(k):null))
        ]);
    }

}